// Service page data — used by Expertise hub and ServiceDetail template
export const services = [
  {
    slug: "civil-litigation",
    title: "Civil Litigation",
    short: "Property disputes, recovery suits, injunctions and contractual claims handled with strategic clarity.",
    seoTitle: "Civil Litigation Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris provides civil litigation support in Gurugram and Delhi NCR for property disputes, recovery matters, injunctions, contractual claims and civil court proceedings.",
    hero:
      "Civil disputes require clear documentation, strong legal strategy and timely representation. Lex Polaris assists clients in civil litigation matters involving property disputes, recovery claims, injunctions, contractual issues and other civil proceedings before appropriate courts and forums.",
    overview: [
      "Civil litigation can arise from property issues, money recovery, breach of agreement, family-owned business conflicts, possession disputes, contractual obligations and other legal disagreements. In many matters, the strength of the case depends on how well the facts are arranged, documents are reviewed and legal remedies are planned at the initial stage.",
      "Lex Polaris provides civil litigation support with a research-driven and strategy-focused approach. The firm works with individuals, businesses, real estate stakeholders and corporate clients to assess the dispute, understand the legal position and build a clear course of action.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Civil suit strategy and filing support",
      "Property and possession dispute matters",
      "Recovery suits and money claims",
      "Injunction matters",
      "Breach of contract disputes",
      "Drafting of plaints, written statements and applications",
      "Evidence and document review",
      "Representation before civil courts",
      "Settlement strategy and dispute negotiation",
      "Appeals and related proceedings",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Property ownership disputes",
      "Possession-related disputes",
      "Contractual claims",
      "Recovery of dues",
      "Injunction and stay matters",
      "Partnership and family business disputes",
      "Civil claims arising from agreements",
      "Execution proceedings",
      "Civil appeals and revisions",
    ],
    audience: [
      "Individuals facing civil disputes",
      "Property owners and buyers",
      "Businesses dealing with contractual claims",
      "Real estate stakeholders",
      "Corporate clients",
      "Families dealing with property or asset-related disputes",
    ],
    approach:
      "At Lex Polaris, every civil matter begins with careful review of documents, facts and available remedies. The focus is not only on filing a case, but on understanding the practical direction of the dispute, possible risks, timelines and the best legal strategy for the client.",
    related: [
      { slug: "property-disputes", title: "Property Disputes" },
      { slug: "commercial-disputes", title: "Commercial Disputes" },
      { slug: "legal-notices-pleadings", title: "Legal Notices & Pleadings" },
      { slug: "dispute-resolution", title: "Dispute Resolution" },
    ],
    faqs: [
      {
        q: "What is civil litigation?",
        a: "Civil litigation involves legal disputes between individuals, businesses or entities where one party seeks relief, compensation, enforcement of rights or protection from harm.",
      },
      {
        q: "Can civil disputes be settled without a long court case?",
        a: "Yes, many civil disputes can be resolved through negotiation, mediation or settlement discussions, depending on the facts and willingness of the parties.",
      },
      {
        q: "What documents are required for a civil litigation consultation?",
        a: "Usually, agreements, notices, ownership documents, payment records, communication records, court papers and any supporting evidence should be reviewed.",
      },
    ],
  },
  {
    slug: "criminal-litigation",
    title: "Criminal Litigation",
    short: "Complaints, defence strategy, bail, trial representation and white-collar crime matters.",
    seoTitle: "Criminal Litigation Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris provides criminal litigation support for complaints, defence strategy, bail matters, criminal trials and white-collar crime matters in Gurugram and Delhi NCR.",
    hero:
      "Criminal matters require immediate attention, careful legal planning and strong representation. Lex Polaris assists clients in criminal complaints, defence matters, bail proceedings, trial strategy, financial crime matters and related criminal litigation.",
    overview: [
      "Criminal litigation can affect personal liberty, reputation, business operations and long-term interests. Whether a person is filing a complaint, responding to allegations or dealing with an investigation, the legal strategy must be precise from the beginning.",
      "Lex Polaris provides criminal litigation support with focus on facts, evidence, procedural compliance and practical legal remedies. The firm assists individuals, businesses and corporate clients in criminal disputes, complaints and defence-related matters.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Criminal complaint drafting and filing",
      "Defence strategy in criminal proceedings",
      "Bail applications and related support",
      "Anticipatory bail matters",
      "Trial preparation and representation",
      "Criminal revision and appeal support",
      "White-collar crime matters",
      "Cheating, fraud and breach of trust matters",
      "Financial crime and business-related criminal disputes",
      "Coordination during investigation-related proceedings",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Criminal complaints",
      "Bail and anticipatory bail",
      "Cheating and fraud allegations",
      "Criminal breach of trust",
      "Business-related criminal disputes",
      "White-collar crime matters",
      "Financial crime allegations",
      "Trial court proceedings",
      "Criminal appeals and revisions",
      "Complaint and summons matters",
    ],
    audience: [
      "Individuals facing criminal allegations",
      "Complainants seeking legal action",
      "Business owners facing fraud or cheating disputes",
      "Corporate clients involved in financial crime matters",
      "Professionals dealing with reputation-sensitive allegations",
    ],
    approach:
      "Criminal litigation demands clarity and speed. Lex Polaris reviews the facts, available records, allegations, procedural status and possible legal remedies before suggesting the next step. The goal is to protect the client’s legal position while ensuring a strategic and responsible response.",
    related: [
      { slug: "legal-notices-pleadings", title: "Legal Notices & Pleadings" },
      { slug: "dispute-resolution", title: "Dispute Resolution" },
      { slug: "commercial-disputes", title: "Commercial Disputes" },
      { slug: "risk-management-regulatory-support", title: "Risk Management & Regulatory Support" },
    ],
    faqs: [
      {
        q: "When should I contact a lawyer in a criminal matter?",
        a: "You should seek legal advice as soon as you receive a complaint, notice, summons, police communication or any indication of criminal allegations.",
      },
      {
        q: "Can Lex Polaris assist with bail matters?",
        a: "Yes, Lex Polaris assists with bail, anticipatory bail and related criminal proceedings, depending on the facts and jurisdiction of the matter.",
      },
      {
        q: "Is criminal litigation only for individuals?",
        a: "No. Businesses and corporate clients may also be involved in criminal disputes, especially in matters related to fraud, financial misconduct, breach of trust and regulatory allegations.",
      },
    ],
  },
  {
    slug: "commercial-disputes",
    title: "Commercial Disputes",
    short: "Contractual conflicts, recovery, shareholder issues and business litigation handled with commercial sense.",
    seoTitle: "Commercial Dispute Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris advises businesses and corporate clients in commercial disputes, contractual conflicts, recovery matters, shareholder issues and business litigation.",
    hero:
      "Commercial disputes can disturb business continuity, financial stability and stakeholder relationships. Lex Polaris assists clients with strategic legal support in contractual disputes, recovery claims, shareholder conflicts, vendor disputes and other business-related disagreements.",
    overview: [
      "In business, disputes often arise from contracts, payments, partnerships, investments, supply arrangements, service obligations and commercial commitments. A delayed or poorly drafted response can weaken the client’s position.",
      "Lex Polaris helps businesses and corporate clients assess the dispute, review documents, understand legal risks and pursue practical remedies through negotiation, notices, litigation or other dispute resolution methods.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Contractual dispute strategy",
      "Recovery and payment dispute matters",
      "Shareholder and partner disputes",
      "Vendor and service provider disputes",
      "Breach of contract claims",
      "Commercial litigation support",
      "Business settlement strategy",
      "Drafting legal notices and replies",
      "Arbitration and dispute resolution support",
      "Pre-litigation advisory",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Breach of commercial agreements",
      "Payment defaults and recovery claims",
      "Vendor and supplier disputes",
      "Shareholder disagreements",
      "Business partnership conflicts",
      "Service agreement disputes",
      "Franchise and distribution disputes",
      "Investment-related disputes",
      "Commercial fraud claims",
      "Contract termination disputes",
    ],
    audience: [
      "Business owners",
      "Start-ups",
      "MSMEs",
      "Corporate clients",
      "Investors",
      "Vendors and service providers",
      "Partners and shareholders",
    ],
    approach:
      "Lex Polaris focuses on protecting the client’s commercial interest while keeping the legal strategy practical. The firm reviews the agreement, transaction history, communication trail, financial exposure and dispute stage before recommending a course of action.",
    related: [
      { slug: "contract-drafting", title: "Contract Drafting" },
      { slug: "corporate-advisory", title: "Corporate Advisory" },
      { slug: "dispute-resolution", title: "Dispute Resolution" },
      { slug: "legal-notices-pleadings", title: "Legal Notices & Pleadings" },
    ],
    faqs: [
      {
        q: "What is a commercial dispute?",
        a: "A commercial dispute is a business-related legal disagreement involving contracts, payments, partnerships, shareholders, vendors, services, investments or commercial obligations.",
      },
      {
        q: "Can a commercial dispute be resolved without litigation?",
        a: "Yes. Many commercial disputes can be handled through negotiation, settlement, mediation, arbitration or legal notice before formal litigation.",
      },
      {
        q: "Why is documentation important in commercial disputes?",
        a: "Documents such as contracts, invoices, emails, payment records and notices help establish rights, obligations, breaches and possible remedies.",
      },
    ],
  },
  {
    slug: "real-estate-rera",
    title: "Real Estate & RERA Matters",
    short: "Delayed possession, refunds, builder-buyer disputes and RERA proceedings for buyers and developers.",
    seoTitle: "RERA Lawyer in Gurugram and Delhi NCR | Real Estate Dispute Lawyer | Lex Polaris",
    metaDescription:
      "Lex Polaris assists homebuyers, developers, investors and real estate stakeholders in RERA matters, delayed possession claims, property disputes and real estate advisory.",
    hero:
      "Real estate disputes need strong documentation, regulatory understanding and practical legal strategy. Lex Polaris assists homebuyers, developers, investors and real estate stakeholders in RERA proceedings, delayed possession claims, compensation matters, property disputes and real estate documentation.",
    overview: [
      "Real estate matters often involve high financial stakes and emotional stress. Delayed possession, defective construction, refund claims, builder-buyer disputes, title concerns, project delays and documentation issues require careful legal handling.",
      "Lex Polaris provides legal support in real estate and RERA matters with focus on clear advice, document review, dispute strategy and representation before relevant authorities and forums.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "RERA complaint drafting and filing",
      "Delayed possession claims",
      "Refund and compensation matters",
      "Builder-buyer disputes",
      "Real estate agreement review",
      "Property documentation support",
      "Due diligence of property records",
      "Developer and buyer advisory",
      "Representation before RERA Authorities",
      "Appeals and related proceedings",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Delayed possession",
      "Refund claims",
      "Compensation claims",
      "Defective construction disputes",
      "Builder-buyer agreement issues",
      "Project delay matters",
      "RERA complaints",
      "Real estate investment disputes",
      "Property documentation concerns",
      "Title and due diligence support",
    ],
    audience: [
      "Homebuyers",
      "Developers",
      "Landowners",
      "Real estate investors",
      "Real estate agents",
      "Corporate real estate stakeholders",
      "RWAs and associations",
    ],
    approach:
      "Lex Polaris reviews the project documents, agreement terms, payment records, communication history, possession status and available remedies before advising on the next step. The aim is to provide legally sound and practical direction in real estate and RERA disputes.",
    related: [
      { slug: "property-disputes", title: "Property Disputes" },
      { slug: "due-diligence", title: "Due Diligence" },
      { slug: "civil-litigation", title: "Civil Litigation" },
      { slug: "legal-notices-pleadings", title: "Legal Notices & Pleadings" },
    ],
    faqs: [
      {
        q: "What is RERA?",
        a: "RERA refers to the Real Estate Regulatory Authority framework created to regulate real estate projects and protect the interests of homebuyers and stakeholders.",
      },
      {
        q: "Can I file a RERA complaint for delayed possession?",
        a: "Yes, depending on the facts, agreement terms and project status, a homebuyer may seek relief for delayed possession, refund, interest or compensation.",
      },
      {
        q: "Do developers also need RERA legal support?",
        a: "Yes. Developers may need legal support for compliance, documentation, buyer disputes, project-related claims and representation before RERA authorities.",
      },
    ],
  },
  {
    slug: "corporate-advisory",
    title: "Corporate Advisory",
    short: "Practical legal advisory for businesses, start-ups and founders across agreements, risk and strategy.",
    seoTitle: "Corporate Advisory Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris provides corporate legal advisory for businesses, start-ups and corporate clients on agreements, compliance, risk, contracts and legal strategy.",
    hero:
      "Businesses need legal advice that is clear, practical and aligned with commercial realities. Lex Polaris provides corporate advisory support for companies, start-ups, founders and business owners across agreements, risk, documentation, compliance and legal strategy.",
    overview: [
      "Corporate legal issues are not limited to disputes. Many risks begin much earlier, during negotiations, documentation, business expansion, vendor arrangements, employment structures, investment conversations or compliance gaps.",
      "Lex Polaris advises businesses on legal decisions that affect operations, contracts, risk exposure and long-term commercial interests. The firm’s approach is practical, preventive and strategy-driven.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Business legal advisory",
      "Contract review and drafting",
      "Founder and shareholder agreements",
      "Vendor and service agreements",
      "Legal risk assessment",
      "Compliance-related advisory",
      "Corporate documentation",
      "Transaction support",
      "Commercial negotiation support",
      "Preventive legal strategy",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Business agreements",
      "Founder arrangements",
      "Shareholder issues",
      "Vendor contracts",
      "Employment-related legal documentation",
      "Investment documentation support",
      "Service agreements",
      "Legal risk review",
      "Corporate notices and replies",
      "Regulatory support",
    ],
    audience: [
      "Start-ups",
      "Founders",
      "MSMEs",
      "Corporate clients",
      "Business owners",
      "Investors",
      "Professional service companies",
    ],
    approach:
      "Lex Polaris focuses on understanding the business objective before drafting or advising. Legal advice should not create confusion for business teams. It should create clarity, reduce risk and support better decision-making.",
    related: [
      { slug: "contract-drafting", title: "Contract Drafting" },
      { slug: "due-diligence", title: "Due Diligence" },
      { slug: "commercial-disputes", title: "Commercial Disputes" },
      { slug: "startup-legal-advisory", title: "Startup Legal Advisory" },
    ],
    faqs: [
      {
        q: "Why do businesses need corporate legal advisory?",
        a: "Corporate legal advisory helps businesses structure agreements, reduce legal risk, manage compliance and make informed commercial decisions.",
      },
      {
        q: "Can start-ups use corporate advisory services?",
        a: "Yes. Start-ups often require legal support for founder agreements, vendor contracts, employment documentation, investment discussions and compliance readiness.",
      },
      {
        q: "Is corporate advisory only needed when there is a dispute?",
        a: "No. Good advisory helps prevent disputes before they arise.",
      },
    ],
  },
  {
    slug: "contract-drafting",
    title: "Contract Drafting & Legal Documentation",
    short: "Enforceable, risk-aware contracts and strategic legal documentation for individuals and businesses.",
    seoTitle: "Contract Drafting Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris drafts and reviews contracts, agreements, legal notices, business documents and strategic legal documentation for individuals and businesses.",
    hero:
      "Strong contracts reduce confusion, protect rights and prevent future disputes. Lex Polaris assists clients with drafting, reviewing and structuring agreements, commercial contracts, notices, pleadings and strategic legal documentation.",
    overview: [
      "A poorly drafted contract can create expensive disputes. Many business and personal legal problems begin with unclear terms, missing obligations, weak remedies or one-sided clauses.",
      "Lex Polaris provides contract drafting and documentation support with attention to legal enforceability, commercial practicality and risk management. The aim is to create documents that are clear, specific and useful in real situations.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Drafting commercial contracts",
      "Reviewing existing agreements",
      "Structuring business arrangements",
      "Drafting notices and replies",
      "Preparing pleadings and applications",
      "Drafting property-related documents",
      "Start-up and founder documentation",
      "Vendor and service agreements",
      "Employment-related documents",
      "Risk-focused document review",
    ],
    mattersTitle: "Documents We Handle",
    matters: [
      "Service agreements",
      "Vendor agreements",
      "Partnership agreements",
      "Founder agreements",
      "Shareholder agreements",
      "Employment contracts",
      "NDAs",
      "MOUs",
      "Legal notices",
      "Replies to notices",
      "Pleadings and petitions",
      "Real estate agreements",
    ],
    audience: [
      "Business owners",
      "Start-ups",
      "Founders",
      "Individuals",
      "Real estate stakeholders",
      "Corporate clients",
      "Professionals and consultants",
    ],
    approach:
      "Lex Polaris drafts documents with clarity, enforceability and practical use in mind. The firm focuses on what can go wrong, how obligations should be recorded and how the client’s position can be protected before a dispute arises.",
    related: [
      { slug: "corporate-advisory", title: "Corporate Advisory" },
      { slug: "legal-notices-pleadings", title: "Legal Notices & Pleadings" },
      { slug: "commercial-disputes", title: "Commercial Disputes" },
      { slug: "due-diligence", title: "Due Diligence" },
    ],
    faqs: [
      {
        q: "Why is contract drafting important?",
        a: "Good contract drafting helps define rights, responsibilities, payment terms, remedies, timelines and dispute resolution mechanisms.",
      },
      {
        q: "Can Lex Polaris review an existing contract?",
        a: "Yes. Existing agreements can be reviewed for legal risk, unclear terms, missing clauses and practical concerns.",
      },
      {
        q: "What makes a contract strong?",
        a: "A strong contract is clear, specific, enforceable and aligned with the actual commercial understanding between the parties.",
      },
    ],
  },
  {
    slug: "due-diligence",
    title: "Due Diligence",
    short: "Risk-first review of property, business and transaction documents before key decisions.",
    seoTitle: "Legal Due Diligence Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris provides legal due diligence support for property transactions, business deals, agreements, documents, investments and corporate matters.",
    hero:
      "Due diligence helps clients identify legal risks before making important decisions. Lex Polaris assists with legal due diligence for property transactions, business arrangements, agreements, investments, corporate records and dispute-sensitive documents.",
    overview: [
      "Before buying property, investing in a business, entering a transaction or signing an important agreement, documents must be checked carefully. Due diligence helps reveal ownership issues, contractual risks, pending disputes, compliance gaps and hidden liabilities.",
      "Lex Polaris provides due diligence support for individuals, businesses, start-ups, real estate stakeholders and corporate clients.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Property document review",
      "Agreement review",
      "Corporate document review",
      "Transaction due diligence",
      "Investment-related legal review",
      "Risk identification",
      "Title and ownership review",
      "Compliance document checks",
      "Litigation and dispute background review",
      "Due diligence report preparation",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Property purchases",
      "Real estate investments",
      "Business transactions",
      "Start-up investment documentation",
      "Commercial agreements",
      "Vendor onboarding",
      "Corporate records",
      "Land and title documents",
      "Contractual risk review",
      "Pre-dispute document review",
    ],
    audience: [
      "Property buyers",
      "Investors",
      "Businesses",
      "Start-ups",
      "Corporate clients",
      "Real estate stakeholders",
      "Founders and promoters",
    ],
    approach:
      "Lex Polaris approaches due diligence with a risk-first mindset. The purpose is not only to read documents, but to understand what those documents mean for the client’s rights, obligations and future exposure.",
    related: [
      { slug: "real-estate-rera", title: "Real Estate & RERA Matters" },
      { slug: "corporate-advisory", title: "Corporate Advisory" },
      { slug: "contract-drafting", title: "Contract Drafting" },
      { slug: "risk-management-regulatory-support", title: "Risk Management & Regulatory Support" },
    ],
    faqs: [
      {
        q: "What is legal due diligence?",
        a: "Legal due diligence is the review of documents, records and legal risks before entering a transaction, investment, purchase or agreement.",
      },
      {
        q: "Is due diligence necessary before buying property?",
        a: "Yes. Property due diligence can help identify ownership issues, title defects, pending disputes, encumbrances and documentation gaps.",
      },
      {
        q: "Can due diligence prevent future disputes?",
        a: "It cannot guarantee that disputes will never happen, but it can reduce risk and help clients make informed decisions.",
      },
    ],
  },
  {
    slug: "legal-notices-pleadings",
    title: "Legal Notices & Pleadings",
    short: "Strategic drafting and replies for notices, pleadings, petitions and applications.",
    seoTitle: "Legal Notice Drafting Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris drafts and responds to legal notices, pleadings, petitions, applications and court-related documents for civil, criminal, commercial and RERA matters.",
    hero:
      "The first legal document can shape the direction of a matter. Lex Polaris assists clients with drafting and responding to legal notices, pleadings, petitions, applications and court-related documents across civil, criminal, commercial, real estate and RERA matters.",
    overview: [
      "Legal notices and pleadings are not routine paperwork. They define facts, claims, legal grounds and the client’s position. A weak notice or unclear pleading can create problems later in the dispute.",
      "Lex Polaris prepares legal documents with focus on facts, legal accuracy, strategy and long-term impact.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Drafting legal notices",
      "Replying to legal notices",
      "Drafting plaints and written statements",
      "Preparing petitions and applications",
      "Drafting complaints and replies",
      "Drafting RERA complaints",
      "Preparing court filings",
      "Reviewing opposing party documents",
      "Strategy for pre-litigation communication",
      "Documentation for dispute escalation",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Recovery notices",
      "Contract breach notices",
      "Property dispute notices",
      "Builder-buyer dispute notices",
      "RERA complaints and replies",
      "Criminal complaints",
      "Civil pleadings",
      "Commercial dispute pleadings",
      "Legal replies",
      "Applications and petitions",
    ],
    audience: [
      "Individuals",
      "Businesses",
      "Start-ups",
      "Corporate clients",
      "Property buyers",
      "Developers",
      "Real estate stakeholders",
    ],
    approach:
      "Lex Polaris treats every legal notice and pleading as a strategic document. The firm focuses on clarity, legal grounds, factual accuracy and future use of the document in negotiation, litigation or dispute resolution.",
    related: [
      { slug: "civil-litigation", title: "Civil Litigation" },
      { slug: "criminal-litigation", title: "Criminal Litigation" },
      { slug: "commercial-disputes", title: "Commercial Disputes" },
      { slug: "real-estate-rera", title: "Real Estate & RERA Matters" },
    ],
    faqs: [
      {
        q: "What is a legal notice?",
        a: "A legal notice is a formal communication sent to another party to raise a legal claim, demand action, respond to a breach or communicate a legal position.",
      },
      {
        q: "Should I reply to a legal notice?",
        a: "Yes, in most cases it is advisable to seek legal advice and respond appropriately. Silence or a poor reply may affect your legal position.",
      },
      {
        q: "Can a legal notice help avoid litigation?",
        a: "Sometimes yes. A well-drafted legal notice can open the door for settlement or compliance before formal proceedings.",
      },
    ],
  },
  {
    slug: "risk-management-regulatory-support",
    title: "Risk Management & Regulatory Support",
    short: "Preventive legal strategy, compliance review and regulatory advisory across business and real estate.",
    seoTitle: "Legal Risk Management and Regulatory Support in Gurugram | Lex Polaris",
    metaDescription:
      "Lex Polaris advises individuals, businesses and corporate clients on legal risk management, regulatory support, compliance concerns and preventive legal strategy.",
    hero:
      "Good legal strategy is not only about solving disputes. It is also about preventing them. Lex Polaris assists clients with legal risk management, regulatory support and preventive legal strategy for business, real estate, corporate and documentation-related matters.",
    overview: [
      "Many legal problems can be avoided through timely review, structured documentation and practical legal advice. Businesses and individuals often face risk because contracts are unclear, compliance is ignored, notices are delayed or decisions are taken without legal review.",
      "Lex Polaris helps clients identify risks early and take informed legal steps before matters become expensive disputes.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Legal risk assessment",
      "Regulatory advisory",
      "Compliance document review",
      "Contract risk review",
      "Business decision legal support",
      "Real estate risk advisory",
      "Dispute prevention strategy",
      "Notice and communication strategy",
      "Pre-litigation advisory",
      "Documentation improvement",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Business risk review",
      "Contract risk assessment",
      "Real estate regulatory concerns",
      "RERA-related compliance issues",
      "Vendor and client risk",
      "Internal documentation gaps",
      "Regulatory notices",
      "Preventive legal advisory",
      "Transaction risk",
      "Dispute-sensitive communication",
    ],
    audience: [
      "Business owners",
      "Start-ups",
      "Corporate clients",
      "Real estate stakeholders",
      "Investors",
      "Founders",
      "Professionals and consultants",
    ],
    approach:
      "Lex Polaris focuses on practical risk reduction. The firm reviews facts, documents and possible outcomes so that clients can take decisions with better clarity and stronger legal protection.",
    related: [
      { slug: "corporate-advisory", title: "Corporate Advisory" },
      { slug: "contract-drafting", title: "Contract Drafting" },
      { slug: "due-diligence", title: "Due Diligence" },
      { slug: "commercial-disputes", title: "Commercial Disputes" },
    ],
    faqs: [
      {
        q: "What is legal risk management?",
        a: "Legal risk management means identifying and reducing legal exposure before it becomes a dispute, claim, penalty or business loss.",
      },
      {
        q: "Do small businesses need legal risk management?",
        a: "Yes. Small businesses and start-ups often face high risk because documentation, contracts and compliance are not structured properly.",
      },
      {
        q: "Can regulatory support help prevent disputes?",
        a: "Yes. Timely regulatory guidance can reduce compliance issues, notices, penalties and future disputes.",
      },
    ],
  },
  {
    slug: "dispute-resolution",
    title: "Dispute Resolution",
    short: "Negotiation, settlement, arbitration and litigation strategy across civil, commercial and real estate matters.",
    seoTitle: "Dispute Resolution Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris provides dispute resolution support through litigation strategy, negotiation, settlement, arbitration support and court representation.",
    hero:
      "Every dispute needs a clear strategy before action is taken. Lex Polaris assists clients in dispute resolution through legal analysis, negotiation strategy, litigation planning, settlement support, arbitration-related assistance and representation before appropriate forums.",
    overview: [
      "Not every dispute should immediately become a long court battle. Some matters need a strong legal notice. Some need negotiation. Some need urgent court intervention. Others may require arbitration, RERA proceedings or tribunal representation.",
      "Lex Polaris helps clients understand the available options and choose a practical legal path based on facts, documents, risks and desired outcomes.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Pre-litigation strategy",
      "Legal notices and replies",
      "Negotiation and settlement support",
      "Litigation strategy",
      "Arbitration-related assistance",
      "Commercial dispute resolution",
      "Real estate dispute resolution",
      "Civil and criminal dispute support",
      "Representation before courts and authorities",
      "Documentation for dispute proceedings",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Business disputes",
      "Contractual disputes",
      "Real estate disputes",
      "Civil disputes",
      "Criminal complaints and defence matters",
      "Recovery disputes",
      "Shareholder and partner disputes",
      "RERA disputes",
      "Property conflicts",
      "Pre-litigation settlements",
    ],
    audience: [
      "Individuals",
      "Businesses",
      "Start-ups",
      "Corporate clients",
      "Property buyers",
      "Developers",
      "Investors and stakeholders",
    ],
    approach:
      "Lex Polaris studies the dispute before recommending the remedy. The focus is on facts, documents, legal options, risk, time, cost and practical outcome. This helps clients avoid emotional decisions and move with clarity.",
    related: [
      { slug: "civil-litigation", title: "Civil Litigation" },
      { slug: "commercial-disputes", title: "Commercial Disputes" },
      { slug: "real-estate-rera", title: "Real Estate & RERA Matters" },
      { slug: "legal-notices-pleadings", title: "Legal Notices & Pleadings" },
    ],
    faqs: [
      {
        q: "What is dispute resolution?",
        a: "Dispute resolution refers to the process of resolving legal disagreements through negotiation, settlement, mediation, arbitration, litigation or other legal mechanisms.",
      },
      {
        q: "Is litigation always required?",
        a: "No. Many disputes can be handled through notices, negotiation, mediation or settlement, depending on the facts.",
      },
      {
        q: "How do I know which dispute resolution method is right?",
        a: "A lawyer can review your documents, facts and goals to suggest whether negotiation, litigation, arbitration or another remedy is suitable.",
      },
    ],
  },
  {
    slug: "property-disputes",
    title: "Property Disputes",
    short: "Title, ownership, possession and recovery matters with strong document strategy.",
    seoTitle: "Property Dispute Lawyer in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris assists clients in property disputes, possession issues, title concerns, ownership conflicts, recovery matters and real estate litigation.",
    hero:
      "Property disputes can affect ownership, possession, investment value and long-term rights. Lex Polaris assists individuals, families, investors and real estate stakeholders in property disputes involving title, possession, agreements, recovery, inheritance-linked issues and real estate documentation.",
    overview: [
      "Property disputes are often document-heavy and emotionally sensitive. They may involve ownership claims, possession issues, buyer-seller conflicts, family arrangements, land records, builder disputes, delayed possession or defective documentation.",
      "Lex Polaris provides legal support for property disputes with focus on document review, legal strategy, court representation and practical dispute resolution.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Property document review",
      "Ownership and title dispute support",
      "Possession dispute strategy",
      "Buyer-seller dispute advisory",
      "Builder-buyer conflict support",
      "Property-related legal notices",
      "Civil suits and injunctions",
      "Recovery and compensation claims",
      "RERA-related property matters",
      "Settlement and negotiation strategy",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Ownership disputes",
      "Possession disputes",
      "Title concerns",
      "Agreement-related disputes",
      "Delayed possession matters",
      "Builder-buyer disputes",
      "Property recovery claims",
      "Family property conflicts",
      "Injunction matters",
      "Real estate documentation issues",
    ],
    audience: [
      "Property owners",
      "Homebuyers",
      "Real estate investors",
      "Families dealing with property conflicts",
      "Developers and builders",
      "Landowners",
      "Corporate real estate stakeholders",
    ],
    approach:
      "Lex Polaris begins property dispute matters by reviewing ownership documents, agreements, payment records, possession status, communication records and available legal remedies. The aim is to protect the client’s rights through clear and strategic legal action.",
    related: [
      { slug: "real-estate-rera", title: "Real Estate & RERA Matters" },
      { slug: "civil-litigation", title: "Civil Litigation" },
      { slug: "due-diligence", title: "Due Diligence" },
      { slug: "legal-notices-pleadings", title: "Legal Notices & Pleadings" },
    ],
    faqs: [
      {
        q: "What should I do first in a property dispute?",
        a: "Collect all property documents, agreements, payment records, notices, emails, messages and possession-related records before seeking legal advice.",
      },
      {
        q: "Can property disputes be resolved without court?",
        a: "Some property disputes can be resolved through negotiation or settlement. Others may require civil court, RERA or tribunal proceedings.",
      },
      {
        q: "Is due diligence important before buying property?",
        a: "Yes. Due diligence can help identify title issues, pending disputes, encumbrances and documentation gaps before purchase.",
      },
    ],
  },
  {
    slug: "startup-legal-advisory",
    title: "Startup Legal Advisory",
    short: "Founder agreements, contracts, compliance and dispute prevention for early-stage and growing businesses.",
    seoTitle: "Startup Legal Advisory in Gurugram and Delhi NCR | Lex Polaris",
    metaDescription:
      "Lex Polaris provides legal advisory for start-ups, founders and growing businesses on contracts, founder arrangements, compliance, risk and dispute prevention.",
    hero:
      "Start-ups need legal clarity from the beginning. Lex Polaris assists founders and growing businesses with contracts, founder arrangements, risk management, advisory, documentation and dispute prevention.",
    overview: [
      "Start-ups often move fast, but legal gaps can create problems later. Unclear founder arrangements, weak vendor contracts, missing employment documentation, informal investments and poorly drafted service agreements can lead to disputes.",
      "Lex Polaris provides practical legal advisory for start-ups and founders with focus on clarity, protection and growth-ready documentation.",
    ],
    assistTitle: "How Lex Polaris Can Assist",
    assist: [
      "Founder agreement support",
      "Contract drafting and review",
      "Vendor and service agreements",
      "Employment and consultant documents",
      "Legal risk assessment",
      "Investment documentation support",
      "Corporate advisory",
      "Compliance-related guidance",
      "Dispute prevention strategy",
      "Legal notices and replies",
    ],
    mattersTitle: "Matters We Handle",
    matters: [
      "Founder disputes",
      "Vendor disputes",
      "Client agreement issues",
      "Service contract drafting",
      "NDA and confidentiality agreements",
      "Employment documentation",
      "Early-stage investment documentation",
      "Brand and IP-related advisory",
      "Business risk review",
      "Pre-litigation advisory",
    ],
    audience: [
      "Start-up founders",
      "Early-stage companies",
      "MSMEs",
      "Growing businesses",
      "Agencies and service companies",
      "Investors",
      "Consultants and professionals",
    ],
    approach:
      "Lex Polaris understands that start-ups need practical legal support, not complicated legal language. The firm helps founders create stronger documents, reduce avoidable risk and take business decisions with legal clarity.",
    related: [
      { slug: "corporate-advisory", title: "Corporate Advisory" },
      { slug: "contract-drafting", title: "Contract Drafting" },
      { slug: "risk-management-regulatory-support", title: "Risk Management & Regulatory Support" },
      { slug: "commercial-disputes", title: "Commercial Disputes" },
    ],
    faqs: [
      {
        q: "Do start-ups need legal advisory from the beginning?",
        a: "Yes. Early legal clarity can prevent founder disputes, contract issues, compliance gaps and avoidable business risk.",
      },
      {
        q: "What legal documents should a start-up have?",
        a: "A start-up should usually have founder agreements, service agreements, vendor contracts, employment or consultant documents, NDAs and clear client contracts.",
      },
      {
        q: "Can Lex Polaris help with start-up disputes?",
        a: "Yes, Lex Polaris assists with founder disputes, vendor issues, client conflicts, payment disputes and contract-related matters.",
      },
    ],
  },
];

export const getServiceBySlug = (slug) => services.find((s) => s.slug === slug);
